// src/utils/formatters.js
import { format, formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const formatPhone = (phone) => {
  if (!phone) return '';
  const numbers = phone.replace(/\D/g, '');
  
  if (numbers.length === 11) {
    return `(${numbers.substring(0, 2)}) ${numbers.substring(2, 7)}-${numbers.substring(7)}`;
  }
  if (numbers.length === 10) {
    return `(${numbers.substring(0, 2)}) ${numbers.substring(2, 6)}-${numbers.substring(6)}`;
  }
  return numbers;
};

export const formatDate = (dateString, type = 'short') => {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    
    if (type === 'relative') {
      return formatDistanceToNow(date, { locale: ptBR, addSuffix: true });
    }
    
    if (type === 'long') {
      return format(date, "dd 'de' MMMM 'de' yyyy", { locale: ptBR });
    }
    
    return format(date, 'dd/MM/yyyy', { locale: ptBR });
  } catch {
    return '';
  }
};

// ✅ ACHADO: antes fixo em pt-BR/BRL sempre — a conta podia escolher outra
// moeda em Configurações > Idioma & Formato (configuracoesGerais.i18n) e o
// valor nunca refletia em lugar nenhum do app. currency/locale agora são
// opcionais (default pt-BR/BRL, 100% retrocompatível com todo call site
// que não passa nada); use o hook useTenantI18n() (useAccounts.js) pra
// obter os valores reais da conta em exibição.
export const formatCurrency = (value, currency = 'BRL', locale = 'pt-BR') => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(value || 0);
};

// Só o símbolo (ex: "R$", "US$", "€") — pra rótulos/prefixos de input que
// não formatam um valor numérico completo, mas ainda assim não deviam
// ficar fixos em "R$". Usa formatToParts em vez de fatiar a string
// formatada (regex tipo replace(/[\d.,\s]/g,'') quebra pra símbolos com
// dígito, como não há hoje, mas é frágil por natureza).
export const getCurrencySymbol = (currency = 'BRL', locale = 'pt-BR') => {
  const parts = new Intl.NumberFormat(locale, { style: 'currency', currency }).formatToParts(0);
  return parts.find(p => p.type === 'currency')?.value || currency;
};

export const getInitials = (name) => {
  if (!name) return '';
  const names = name.trim().split(' ');
  if (names.length === 1) return names[0].charAt(0).toUpperCase();
  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
};

export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return `${text.substring(0, maxLength)}...`;
};